import { makeStyles } from '@material-ui/core/styles'
import { Link, Button, Grid, useTheme, useMediaQuery } from '@material-ui/core'
import React from 'react'
import { Image, Transformation } from 'cloudinary-react'
import { CLOUDINARY_NAME } from '../../../constants'
import { ABOUT } from '../../../routes'

const useStyles = makeStyles((theme) => ({
    bg: {
        background: theme.palette.primary.main,
        padding: '0 2rem',
        display: 'flex',
        justifyContent: 'center',
    },
    gridContainer: {
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            padding: '3rem',
            width: '1440px',
            marginTop: '3rem',
            marginBottom: '3rem',
        },
    },
    textContainer: {
        [theme.breakpoints.up('md')]: {
            width: '550px',
        },
    },
    h2: {
        color: '#fff',
        fontSize: '1.3rem',
        [theme.breakpoints.up('md')]: {
            marginTop: 0,
        },
    },
    p: {
        color: '#fff',
    },
    link: {
        color: '#fff',
        fontWeight: '600',
    },
    button: {
        color: theme.palette.primary.main,
        borderRadius: '5px',
        fontWeight: '700',
        padding: '12px 24px 12px 12px',
        background: 'white',
        marginTop: '.5rem',
        textTransform: 'none',
        [theme.breakpoints.up('md')]: {
            width: '250px',
            marginTop: '1.5rem',
        },
        '&:hover': {
            backgroundColor: 'white!important',
            color: `${theme.palette.primary.main}!important`,
        },
    },
    img: {
        margin: '5px',
        borderRadius: '5px',
    },
    topImg: {
        margin: '5px',
        borderRadius: '5px',
        [theme.breakpoints.up('md')]: {
            margin: '0 5px 10px 5px',
        },
    },
    imgItem: {
        margin: '0 8px',
    },
    imgContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        marginTop: '1.5rem',
        [theme.breakpoints.up('md')]: {
            width: '37.5rem',
        },
        [theme.breakpoints.up('lg')]: {
            marginTop: 0,
        },
    },
    imgContainerChild: {
        [theme.breakpoints.down('md')]: {
            marginLeft: '-15px',
            marginBottom: '25px',
        },
    },
}))

const RealPeopleSection = ({ baseUrl }) => {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
        defaultMatches: true,
    })

    return (
        <div className={classes.bg}>
            <Grid container className={classes.gridContainer} spacing={0}>
                <Grid
                    item
                    lg={6}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <div className={classes.textContainer}>
                        <h2 className={classes.h2}>
                            Real People. Real hard work.
                        </h2>
                        <p className={classes.p}>
                            Over 150 team members spanning 21 states, 6 time
                            zones, 4 countries and 2 U.S. territories, and 1,082
                            years of combined experience. We are an elite team
                            of gift card and fin-tech powerhouses working to
                            make Gift Card Granny a household name. We are
                            adventure seekers and DIYers. Dads, moms,
                            grandparents, and pet parents. Gen Z, Millennials,
                            Gen X, and Boomers. Wood workers, chefs, Star Wars
                            fans, and musicians.
                        </p>
                        <p className={classes.p}>
                            <strong>
                                Oh, and we all have one mission;
                                <br /> to work hard, be nice, & create the next
                                generation of gifting.
                            </strong>
                        </p>
                        <Button
                            href={baseUrl + ABOUT}
                            className={classes.button}
                        >
                            More about us
                        </Button>
                    </div>
                </Grid>
                <Grid
                    item
                    lg={6}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <div className={classes.imgContainer}>
                        <div className={classes.imgContainerChild}>
                            <div className={classes.imgItem}>
                                <Image
                                    cloudName={CLOUDINARY_NAME}
                                    className={classes.topImg}
                                    publicId={
                                        'GCG/legit_page/lg-team-photo_vxancz'
                                    }
                                    loading="lazy"
                                    title={`Team photo with all together`}
                                    alt={`Team photo with all together`}
                                    width={isMobile ? '255' : '584'}
                                    height={isMobile ? '110' : '253'}
                                >
                                    <Transformation
                                        width={'584'}
                                        crop="scale"
                                        fetchFormat="auto"
                                    />
                                </Image>
                            </div>

                            <div style={{ display: 'flex' }}>
                                <div className={classes.imgItem}>
                                    <Image
                                        cloudName={CLOUDINARY_NAME}
                                        className={classes.img}
                                        publicId={
                                            'GCG/legit_page/bottom_left-team-photo_ey1vw4'
                                        }
                                        loading="lazy"
                                        title={`Team photo with Penguins jersey`}
                                        alt={`Team photo with Penguins jersey`}
                                        width={isMobile ? '115' : '279'}
                                        height={isMobile ? '85' : '206'}
                                    >
                                        <Transformation
                                            width={'279'}
                                            crop="scale"
                                            fetchFormat="auto"
                                        />
                                    </Image>
                                </div>
                                <div className={classes.imgItem}>
                                    <Image
                                        cloudName={CLOUDINARY_NAME}
                                        className={classes.img}
                                        publicId={
                                            'GCG/legit_page/bottom_right_team_photo_qefx6b'
                                        }
                                        loading="lazy"
                                        title={`Team photo playing kickball`}
                                        alt={`Team photo playing kickball`}
                                        width={isMobile ? '115' : '279'}
                                        height={isMobile ? '85' : '206'}
                                    >
                                        <Transformation
                                            width={'279'}
                                            crop="scale"
                                            fetchFormat="auto"
                                        />
                                    </Image>
                                </div>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default RealPeopleSection
